<template>
	<div class="default-wrapper">
	  <div class="header-wrapper">
	  	<d-container fluid class="p-0">
		  	<d-row no-gutters>
	  	        <d-col style="max-width:190px;">
	  	        	<d-input v-model="searchString" class="mb-2" size="sm" type="text" placeholder="Wyszukaj fanzone..." />
	  	        </d-col>
	  	        <d-col class="ml-5 mr-5">
	  	        	pokaz archiwum
	  	        </d-col>
	  	    </d-row>
	  	</d-container>
	  </div>
	  <loader v-if="$store.state.loading" />
	  <div v-else class="cards-wrapper">
	  	  	<d-link tag="div" v-for="(fanzone, i) in filteredFanzones" :key="i" :to="`/${url}/${fanzone.id}`">
	  		  	<d-card style="max-width:200px; margin:0 1rem 1rem 0; flex: 1 0 auto;">
	  		  	    <d-card-img v-if="imageUrl(fanzone)" :src="imageUrl(fanzone)" style="width:200px;height:200px;border-radius: 8px 8px 0 0;"/>
	  		  	    <d-card-body>
	  		  	        <p>{{ fanzone.name }}</p>
	  		  	    </d-card-body>
	  		  	</d-card>
	  	  	</d-link>
	  </div>
	</div>
</template>

<script>
	export default {
    props: ['fanzoneTypesIds', 'url'],
		data() {
			return {
				loading: true,
				searchString: '',
			}
		},
		computed: {
			filteredFanzones() {
        let fanzones = this.getFanzonesByCategoriesArray()
        if (this.searchString === '') {
          return fanzones
				}
				let searchString = this.searchString.toUpperCase()
        return fanzones.filter((fanzone) => fanzone.name.toUpperCase().indexOf(searchString) !== -1)
			},
		},
		mounted() {
			console.log('CARD VIEW')
		},
		methods: {
			imageUrl(fanzone) {
				return fanzone.image_url || fanzone.image
			},
      getFanzonesByCategoriesArray(){
        let fanzones = []
        this.fanzoneTypesIds.map(id => { 
            if (this.$store.state.fanzones.fanzonesByTypeId[id]) {
              fanzones = [...fanzones, ...this.$store.state.fanzones.fanzonesByTypeId[id]]
            }
          }
        )
        return fanzones
      }
		}
	}
</script>

<style scoped lang="less">
	.cards-wrapper {
		display:flex;
		flex-wrap:wrap;
		
		> div {
			cursor:pointer;
		}
	}
</style>